import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import Button from 'components/ui/button';
import { cdnURL } from 'components/utils/cdn';

import { useMember } from 'hooks/member';
import { useIsMobile } from 'hooks/app';

import './styles.scss';


const BirthdayRequestHelp = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useMember();
  const isMobile = useIsMobile();


  const goToLogin = () => {
    navigate('/register?next=/reminders/birthday/add');
  }

  const goToReminders = () => {
    navigate('/reminders/birthday/add');
  }

  const addRemindersLink = isLoggedIn ? '/reminders/birthday/add' : '/login?next=/reminders/birthday/add';
  const addRemindersManuallyLink = isLoggedIn ? '/reminders/birthday/add/manual' : '/login?next=/reminders/birthday/add/manual';
  const emailSettingsLink = isLoggedIn ? '/email_settings' : '/login?next=/email_settings';
  return (
    <div className="birthday-request-seo-container">
      <h1 className="SSR-page-header">{`${isMobile ? 'Set Up Reminders' : 'How To Set Up Your Free Reminders'}`}</h1>
      <div className="seo-container-help">
        <div className="seo-header">
          <h1 className="seo-header-title">Be a Birthday Hero!</h1>
          <h2 className="seo-header-subtitle-bold">You can be a hero with Birthday Alarm’s reminder service!</h2>
          <h2 className="seo-header-subtitle">We’ll alert you when an important event happens so you never miss a chance to show your friends and family how special they are.</h2>
          <br/>
          <div className="seo-header-button">
            <Button onClick={isLoggedIn ? goToReminders : goToLogin}>Get Birthdays</Button>
          </div>
        </div>
        <div className="seo-contents-1">
          <span className="seo-text">Do you know the birthdays of everyone you care about? Most people don’t.</span>
          <span className="seo-text">But now you can collect your loved ones’ birth dates and set up a handy birthday reminder list at the same time.</span>
          <span className="seo-text">You can set reminders for other events too. Holidays, anniversaries — you name it!</span>
        </div>
        <div className="seo-contents-2">
          <div className="content-item">
            <div className="info-text-1">
              <span className="text">Let’s start with the most important information: our reminder service is available for the bargain price of... FREE!</span>
            </div>
            <div className="info-text-2">
              <span className="text-title">Free and Easy</span>
              <span className="text-subtitle">There are no hidden costs to store your reminders and you can use them without making a purchase. Our reminder service has always been free and always will be. Of course, a great way to help celebrate all those birthdays you’re reminded of is to send cards. Our premium membership allows you to send as many fun and eclectic messages as you like for a small yearly fee. We have thousands to choose from so you’re sure to find one that’s just right for the birthday boy or girl.</span>
            </div>
          </div>
          <div className="content-item">
            <div className="info-text-1">
              <span className="text">We take your privacy seriously and we take your friends’ privacy seriously too.</span>
            </div>
            <div className="info-text-2">
              <span className="text-title">Safe and Private</span>
              <span className="text-subtitle">We take your privacy seriously and we take your friends’ privacy seriously too. You can read our <Link to="/privacy" target="_blank"><b>Privacy Policy</b></Link> to understand the specific details of how we use your information but know that we do not share your personal information with any third parties and we don’t spam you. Period.</span>
            </div>
          </div>
        </div>
        <div className="seo-contents-3">
          <span className="seo-title">Add Birthday Reminders Quickly and Easily</span>
          <span className="seo-subtitle">There are three easy ways to set up birthday reminders:</span>
          <div className="options">
            <div className="option">
              <img className="image-1" src={cdnURL('img/rebuild/promote/email/email_send_round.png')} alt=""/>
              <span className="option-title">Make it Easy</span>
              <span className="option-subtitle">The first way—and the easiest—is to use our email import service. {isLoggedIn ? 'Head' : 'Log into your account and head'} over to the <Link to={addRemindersLink}>Add Reminders</Link> page.</span>
              <span className="option-info">Import your online address book and pull in a list of your friends and family, then pick and choose whose birthday you want in your reminder list. We’ll send out a personalized link where your friends can fill in their name, email and date of birth.</span>
              <br />
              <div className="option-button">
                <Button onClick={isLoggedIn ? goToReminders : goToLogin}>Add Reminders</Button>
              </div>
            </div>
            <div className="option">
              <img className="image-2" src={cdnURL('img/rebuild/promote/svg/link.svg')} alt=""/>
              <span className="option-title">Share a Link</span>
              <span className="option-subtitle">You can also paste your magic link into any email or messaging app you want! {isLoggedIn ? 'Head' : 'Log into your account and head'} over to the <Link to={addRemindersLink}>Add Reminders</Link> page.</span>
              <span className="option-info">Copy the link into email, text, facebook and more! Your friends will click the link and will be taken to a customized web form where your friends can fill in their name, email and date of birth.</span>
              <br/>
              <br/>
              <div className="option-button">
                <Button onClick={isLoggedIn ? goToReminders : goToLogin}>Get Started</Button>
              </div>
            </div>
            <div className="option">
              <img className="image-3" src={cdnURL('img/rebuild/promote/svg/form.svg')} alt=""/>
              <span className="option-title">Add Manually</span>
              <span className="option-subtitle">Want to enter someone’s special date without sending them an email? You can do that, too. Add their basic information - name, email and birth date - to our <Link to={addRemindersManuallyLink}>simple form</Link> and you’re all set.</span>
              <span className="option-info">Adding contacts and birthdays manually is easy and straight forward!</span>
              <div className="option-button">
                <Button onClick={isLoggedIn ? goToReminders : goToLogin}>Add Manually</Button>
              </div>
            </div>
          </div>
        </div>
        <div className="seo-contents-4">
          <div className="content-item">
            <div className="info-image">
              <img src={cdnURL('img/rebuild/promote/email/email_send.png')} alt=""/>
            </div>
            <div className="info-details">
              <span className="text-title">Birthday Email Alerts</span>
              <span className="text-subtitle">Once you’ve added someone’s birthday, we take over the hard stuff.</span>
              <span className="text-info">We watch the calendar and let you know when a birthday is approaching. You might forget that Aunt Linda’s birthday is coming up, but we won’t. We’ll send you a reminder a week before her special day to jog your memory and give you plenty of time to pick a card and schedule it for delivery. But sometimes you’re busy when you get a notification and you immediately forget about it…again. No sweat – we’ll send you a second reminder three days before the birthday. If that schedule doesn’t work for you, you can always switch up the timing of the emails in your <Link to={emailSettingsLink}>notifications settings</Link>. Our goal is to make you look like a birthday super hero so you do what works for you.</span>
            </div>
          </div>
          <div className="content-item">
            <div className="info-image">
              <img src={cdnURL('img/rebuild/promote/thank-you/card_types.png')} alt=""/>
            </div>
            <div className="info-details">
              <span className="text-title">Send Cards</span>
              <span className="text-subtitle">When you get a reminder, it’s time for the fun stuff –  picking and sending a card!</span>
              <span className="text-info">We have thousands of beautiful premium cards in our collection so you can find  just the right message for a <Link to="/cards/birthday-wishes?ccid=1"><b>birthday</b></Link>, <Link to="/cards/anniversary?ccid=186"><b>anniversary</b></Link> or <Link to="/cards/holidays?ccid=5"><b>holiday</b></Link>. Personalize your card and send it right away or schedule it for a few days, weeks, or months out.</span>
            </div>
          </div>
        </div>
        <div className="seo-contents-5">
          <span className="seo-title">Wow! Look how easy thas was.</span>
          <br/>
          <br/>
          <div className="option-button">
            <Button onClick={isLoggedIn ? goToReminders : goToLogin} color="black">Get Started</Button>
          </div>
        </div>
        <div className="seo-contents-7">
          <div className="info-container">
            <div className="info-image">
              <img src={cdnURL('img/rebuild/promote/svg/bday.svg')} alt=""/>
            </div>
            <div className="info-text">
              <span>Established in 2001, BirthdayAlarm is the trusted <span className="info-text-bold">FREE reminder service</span> with over 50 Million users. We remember the date, so you can celebrate!</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BirthdayRequestHelp;
